// extracted by mini-css-extract-plugin
export default {"headerAlignment":"IxpRZv","contentAlignment":"ZZw42R","contentAlignmentJustify":"JeZK98"};